// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CloseCircleTwoToneSvg from "@fishx/icons-svg/es/asn/CloseCircleTwoTone";
import FishxIcon from '../components/FishxIcon';

var CloseCircleTwoTone = function CloseCircleTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CloseCircleTwoToneSvg
  }));
};

CloseCircleTwoTone.displayName = 'CloseCircleTwoTone';
export default React.forwardRef(CloseCircleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CloseCircleTwoTone.js
// module id = 2231
// module chunks = 0